// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { Credential } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { ProviderConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Provider';
import { RegistrarServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useAcceptRegistrarServiceRequest: () => UseMutationResult<
  void,
  string,
  {
    registrarServiceRequestCid: ContractId<RegistrarServiceRequest>;
    providerConfigurationCid: ContractId<ProviderConfiguration>;
    credentialCids: ContractId<Credential>[];
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useMutation({
    mutationKey: ['acceptRegistryRegistrarServiceRequest', ledgerApi, operator],
    mutationFn: async ({
      registrarServiceRequestCid,
      providerConfigurationCid,
      credentialCids,
    }) => {
      return ledgerApi.acceptRegistryRegistrarServiceRequest(
        registrarServiceRequestCid,
        providerConfigurationCid,
        credentialCids,
      );
    },
  });
};

export default useAcceptRegistrarServiceRequest;
